import { bootstrapApplication } from '@angular/platform-browser';
import { KnkxRootPage } from './app/pages/app/root-page/root.page';
import { knkxConfig } from './app/knkx.config';

bootstrapApplication(KnkxRootPage, knkxConfig).catch((err) =>
  console.error(err)
);
